import { type ReactNode, Fragment } from 'react';

import clsx from 'clsx';
import { Dimension } from '../Dimension/Dimension';
import styles from './Header.module.css';

function Actions({
  actions,
  containerClassName,
}: {
  actions?: ReactNode[];
  containerClassName?: string;
}) {
  if (!actions || !actions.length) return null;

  return (
    <div className={containerClassName}>
      {actions.map((action, idx) => (
        <Fragment key={idx}>{action}</Fragment>
      ))}
    </div>
  );
}

interface Props {
  className?: string;
  rightAlignedActions?: ReactNode[];
  leftAlignedActions?: ReactNode[];
  centerElement?: ReactNode;
  children?: ReactNode;
  transparent?: boolean;
  /** Maintain the mobile layout even on desktop */
  maintainLayout?: boolean;
}

const LOGO_PATH = '/public/img/logos/hr-logo-smile-red.svg';

export const Logo = () => (
  <img
    className={styles.logo}
    alt="Hungryroot"
    height="67"
    width="143"
    src={LOGO_PATH}
  />
);

export function Header({
  children,
  className,
  rightAlignedActions,
  leftAlignedActions,
  centerElement,
  transparent = false,
  maintainLayout = false,
}: Props) {
  const containerClassName =
    transparent === true
      ? styles['outer-container-transparent']
      : styles['outer-container'];

  return (
    <Dimension
      level={transparent === true ? 'none' : 'two'}
      as="header"
      className={clsx(containerClassName, className)}
    >
      <div
        className={clsx(styles.container, {
          [styles['maintain-layout']]: maintainLayout,
        })}
      >
        <Actions
          actions={leftAlignedActions}
          containerClassName={styles['left-aligned-actions']}
        />
        <div className={styles['center-element-wrapper']}>
          {centerElement ?? <Logo />}
        </div>
        <Actions
          actions={rightAlignedActions}
          containerClassName={styles['right-aligned-actions']}
        />
        {children !== undefined && (
          <div className={styles.children}>{children}</div>
        )}
      </div>
    </Dimension>
  );
}
